<div class="ladder-layout">
  <div class="container-fluid blotter_top_interaction_bar" #topMenu *ngIf="!embeddedTableMode">
    <div class="blotter_titlebar_interaction">
      <div class="blotter_filter_bar_container">
        <div
          class="bfx-blotter-filter-bar blotter_filter_bar bar-with-temp"
          [blotterInstance]="blotterInstance"
        ></div>
      </div>
      <div class="bfx-blotter-tools-container">
        <bfx-quick-search
          class="bfx-quick-search"
          [(ngModel)]="searchValue"
          (ngModelChange)="onChangeSearchValue()"
        ></bfx-quick-search>
        <div class="blotter_titlebar_interaction_right">
          <bfx-icon-button
            size="sm"
            iconClass="icon_ion_filter_filled"
            (action)="showFilterManager($event)"
            title="Filter Manager"
          ></bfx-icon-button>
          <bfx-icon-button
            size="sm"
            iconClass="icon_ion_settings_filled"
            (action)="settingsMenu.toggle($event)"
            title="Settings"
          ></bfx-icon-button>
          <bfx-blotter-settings-menu #settingsMenu></bfx-blotter-settings-menu>
        </div>
      </div>
    </div>
  </div>

  <div
    class="container-fluid blotter_top_interaction_bar"
    #topMenu
    *ngIf="embeddedTableMode && embeddedTableModeSearchDealtToggle"
  >
    <div class="blotter_titlebar_interaction">
      <div class="blotter_filter_bar_container"></div>
      <div class="bfx-blotter-tools-container">
        <bfx-quick-search
          class="bfx-quick-search"
          [(ngModel)]="searchValue"
          (ngModelChange)="onChangeSearchValue()"
        ></bfx-quick-search>
      </div>
    </div>
  </div>
  <div
    class="blotter_table_target"
    ngClass="{ 'ladder-table': showFullTray && (this.searchValue == null || this.searchValue.trim().length == 0); 'ladder-table-no-tray' : !(showFullTray && (this.searchValue == null || this.searchValue.trim().length == 0)) }"
    #tableTarget
  >
    <ag-grid-angular
      style="width: 100%; height: 100%"
      rowHeight="22"
      class="ag-bcdfx ag-bcdfx-ladder pinned-border"
      [columnDefs]="columnDefs"
      [gridOptions]="gridOptions"
      [toolPanelSuppressSideButtons]="true"
      enableColResize
      enableSorting
      multiSortKey="ctrl"
      [frameworkComponents]="frameworkComponents"
      (mousewheel)="onMouseWheel($event)"
      (mousedown)="onMouseDown($event)"
      (mouseup)="onMouseUp($event)"
      (keydown)="onKeyPress($event)"
      (contextmenu)="handleClick($event)"
      [ngClass]="{'fullTempStyled': isFullTempStyle===true}"
      [class._bfx_flash]="flashRow"
    >
    </ag-grid-angular>
  </div>
  <div
    class="ladder-pairs-container"
    *ngIf="showFullTray && (this.searchValue == null || this.searchValue.trim().length == 0)"
  >
    <div class="ladder-pairs">
      <div
        *ngFor="let pair of service.ladderPairTrayProvider; trackBy: ladderPairTrackBy"
        [ngClass]="{'pair-button-wrapper':!pair.pairIsEmpty}"
      >
        <div
          *ngIf="!pair.pairIsEmpty"
          (mouseover)="onPairHovered(pair)"
          title="{{currencyPairTooltip}}"
        >
          <!--<svg *ngIf="!pair.tradable" class="pair-button-svg" (click)="onPairClicked(pair)">
            <line
              *ngIf="pair.temperature!=2"
              x1="0"
              y1="30px"
              x2="30px"
              y2="0"
              style="stroke: rgba(173, 26, 38, 80%); stroke-width: 4"
              stroke-linecap="round"
            />
            <line
              *ngIf="pair.temperature==2"
              x1="0"
              y1="30px"
              x2="30px"
              y2="0"
              style="stroke: rgba(255, 255, 255, 80%); stroke-width: 4"
              stroke-linecap="round"
            />
          </svg> -->
          <button
            (click)="onPairClicked(pair)"
            [ngClass]="{'pair-button':true,
                                        'pair-cold': pair.temperature==0,
                                        'pair-warm': pair.temperature==1,
                                        'pair-hot': pair.temperature==2,
                                        'pair-triggered': pair.temperature==3,
                                        'pair-non-tradable': !pair.tradable}"
          >
            {{pair.isInvert ? pair.nonBaseCode : pair.baseCode}}<br />{{pair.isInvert ?
            pair.baseCode : pair.nonBaseCode}}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
<bfx-ladder-orders-context-menu
  *ngIf="!embeddedTableMode"
  [currentLadderBlotter]="blotterInstance"
  bfxElementOnBody
></bfx-ladder-orders-context-menu>
<bfx-blotter-column-selector [currentLadderBlotter]="blotterInstance" bfxElementOnBody>
</bfx-blotter-column-selector>
